"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("./icon"));

var _key_press_options_handler = _interopRequireDefault(require("./utils/key_press_options_handler"));

var _labeled_icon = _interopRequireDefault(require("./labeled_icon"));

var _labeled_flag = _interopRequireDefault(require("./labeled_flag"));

var _select_content = _interopRequireDefault(require("./select_content"));

require("../css/select.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidMount", function () {
      window.addEventListener('click', _this.handleWindowClick);
      window.addEventListener('keydown', _this.handleWindowKeyDown);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentDidUpdate", function (prevProps, prevState) {
      var titleLongerThanBox = _this.isTitleLongerThanBox();

      if (titleLongerThanBox !== prevState.titleLongerThanBox) {
        _this.setState({
          titleLongerThanBox: titleLongerThanBox
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
      window.removeEventListener('click', _this.handleWindowClick);
      window.removeEventListener('keydown', _this.handleWindowKeyDown);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getSelectedOptions", function (options, selectedOptions, value, displayOptions) {
      var updatedSelectedOptions = [];
      value.length > 0 && value.forEach(function (selectedValue) {
        var optionIndex = options.findIndex(function (option) {
          return option.value === selectedValue;
        });
        var selectedIndex = selectedOptions.findIndex(function (option) {
          return option.value === selectedValue;
        });

        if (displayOptions) {
          var hiddenSelectedValue = displayOptions.find(function (option) {
            return option.value === selectedValue;
          });

          if (optionIndex === -1 && selectedIndex === -1) {
            updatedSelectedOptions.push(hiddenSelectedValue);
          }
        }

        if (optionIndex !== -1 && selectedIndex === -1) {
          updatedSelectedOptions.push(options[optionIndex]);
        }

        if (selectedIndex !== -1) {
          updatedSelectedOptions.push(selectedOptions[selectedIndex]);
        }
      });
      return updatedSelectedOptions;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTitle", function () {
      var _this$props = _this.props,
          multiple = _this$props.multiple,
          placeholder = _this$props.placeholder;
      var selectedOptions = _this.state.selectedOptions;

      if (selectedOptions.length === 0) {
        return placeholder;
      }

      if (multiple) {
        var contents = selectedOptions.map(function (option) {
          return option.altLabel || option.label || option.value;
        });
        return contents.join(', ');
      }

      var option = selectedOptions[0];
      return option.altLabel || option.label || option.value;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "addIconIfNeeded", function (title) {
      var selectedOptions = _this.state.selectedOptions;
      var option = selectedOptions[0];

      if (option && (option.icon || option.flag)) {
        var labeledIcon;

        if (option.icon) {
          labeledIcon = _react.default.createElement(_labeled_icon.default, {
            name: option.icon,
            label: title
          });
        } else {
          labeledIcon = _react.default.createElement(_labeled_flag.default, {
            name: option.flag,
            label: title
          });
        }

        return labeledIcon;
      }

      return title;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focusTitleIfNeeded", function () {
      var focused = _this.state.focused;

      if (focused === true && _this.titleTextNode) {
        _this.titleTextNode.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isTitleLongerThanBox", function () {
      var multiple = _this.props.multiple;
      if (!multiple) return false;
      if (_this.hiddenTitleTextNode === null) return false;
      return _this.hiddenTitleTextNode.scrollWidth > _this.hiddenTitleTextNode.clientWidth;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "closeContent", function () {
      var focused = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var onSearch = _this.props.onSearch;

      _this.setState({
        focused: focused,
        open: false
      }, _this.focusTitleIfNeeded);

      if (onSearch) {
        onSearch('');
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBlur", function (event) {
      event.preventDefault();

      _this.setState({
        focused: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (option, close) {
      var onChange = _this.props.onChange;

      if (close) {
        _this.closeContent();
      }

      if (!option) {
        return;
      }

      onChange(option);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClearClick", function () {
      var onClear = _this.props.onClear;
      var selectedOptions = _this.state.selectedOptions;

      if (_this.isDisabled()) {
        return;
      }

      _this.closeContent();

      onClear(selectedOptions);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (event) {
      event.preventDefault();
      var options = _this.props.options;
      var open = _this.state.open;

      if (_this.isDisabled()) {
        return;
      }

      if (!open && options.length === 0) {
        return;
      }

      if (open) {
        _this.closeContent();
      } else {
        _this.openContent();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocus", function (event) {
      event.preventDefault();

      if (_this.isDisabled()) {
        return;
      }

      _this.setState({
        focused: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDown", function (event) {
      var _this$props2 = _this.props,
          multiple = _this$props2.multiple,
          options = _this$props2.options,
          value = _this$props2.value;
      var open = _this.state.open;

      if (_this.isDisabled()) {
        return;
      }

      var selectedIndex = options.findIndex(function (option) {
        return option.value === value[0];
      });

      switch (event.keyCode) {
        case 13: // ENTER

        case 32:
          // SPACE
          event.preventDefault();
          event.stopPropagation();

          _this.openContent();

          break;

        case 27:
          // ESC
          _this.closeContent();

          break;

        case 38:
          // UP
          event.preventDefault();

          if (!multiple && !open && selectedIndex > 0) {
            _this.nextOptionSelection(38, selectedIndex);
          }

          break;

        case 40:
          // DOWN
          event.preventDefault();

          if (!multiple && !open && selectedIndex < options.length - 1) {
            _this.nextOptionSelection(40, selectedIndex);
          }

          if (multiple) {
            _this.openContent();
          }

          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDownClear", function (event) {
      switch (event.keyCode) {
        case 13: // ENTER

        case 32:
          // SPACE
          event.preventDefault();
          event.stopPropagation();

          _this.handleClearClick();

          break;

        case 27:
          // ESC
          _this.closeContent();

          break;

        default:
          _this.handleKeyDown(event);

      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyPress", function (event) {
      var readOnly = _this.props.readOnly;

      if (_this.isDisabled() || readOnly) {
        return;
      }

      event.preventDefault();

      _this.keyPressOptionsHandler.handle(event.key);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleWindowClick", function (event) {
      var open = _this.state.open;
      if (_this.selectNode && _this.selectNode.contains(event.target)) return;

      if (open) {
        _this.closeContent(false);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleWindowKeyDown", function (event) {
      var open = _this.state.open;

      switch (event.keyCode) {
        case 27: // ESC

        case 13:
          // ENTER
          if (open) {
            _this.closeContent(false);
          }

          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyPressOptionsHandlerCallback", function (index) {
      var _this$props3 = _this.props,
          multiple = _this$props3.multiple,
          onChange = _this$props3.onChange,
          options = _this$props3.options;
      var open = _this.state.open;

      if (index >= 0 && multiple && !open) {
        _this.setState({
          focused: true,
          highlightedIndex: index,
          open: true
        });
      }

      if (index >= 0 && !multiple && !open) {
        onChange(options[index]);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "nextOptionSelection", function (keyCode, selectedIndex) {
      var _this$props4 = _this.props,
          onChange = _this$props4.onChange,
          options = _this$props4.options;
      var nextIndex = selectedIndex;
      nextIndex = keyCode === 40 ? nextIndex + 1 : nextIndex - 1;

      while (nextIndex >= 0 && nextIndex <= options.length - 1) {
        if (options[nextIndex].disabled === true) {
          nextIndex = keyCode === 40 ? nextIndex + 1 : nextIndex - 1;
        } else {
          break;
        }
      }

      onChange(options[nextIndex]);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isDisabled", function () {
      var _this$props5 = _this.props,
          disabled = _this$props5.disabled,
          options = _this$props5.options,
          showSearch = _this$props5.showSearch;
      var open = _this.state.open;
      return disabled || options.length === 0 && !showSearch || showSearch && options.length === 0 && !open;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openContent", function () {
      _this.setState({
        focused: true,
        highlightedIndex: 0,
        open: true
      });
    });

    var _displayOptions = props.displayOptions,
        _options = props.options,
        _value = props.value;

    var _selectedOptions = _this.getSelectedOptions(_options, [], _value, _displayOptions);

    _this.keyPressOptionsHandler = new _key_press_options_handler.default(_options, _this.keyPressOptionsHandlerCallback, 500);
    _this.state = {
      focused: false,
      open: false,
      selectedOptions: _selectedOptions,
      titleLongerThanBox: false
    };
    _this.hiddenTitleTextNode = null;
    _this.titleTextNode = null;
    return _this;
  }

  _createClass(Select, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var displayOptions = nextProps.displayOptions,
          value = nextProps.value;
      var options = this.props.options;
      var selectedOptions = this.state.selectedOptions;
      var newSelectedOptions = this.getSelectedOptions(nextProps.options, selectedOptions, value, displayOptions);

      if (options !== nextProps.options) {
        this.keyPressOptionsHandler = new _key_press_options_handler.default(nextProps.options, this.keyPressOptionsHandlerCallback, 500);
      }

      if (selectedOptions !== newSelectedOptions) {
        this.setState({
          selectedOptions: newSelectedOptions
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props6 = this.props,
          clearIcon = _this$props6.clearIcon,
          error = _this$props6.error,
          i18n = _this$props6.i18n,
          id = _this$props6.id,
          multiple = _this$props6.multiple,
          onScrollEnd = _this$props6.onScrollEnd,
          onSearch = _this$props6.onSearch,
          options = _this$props6.options,
          optionsOrientation = _this$props6.optionsOrientation,
          readOnly = _this$props6.readOnly,
          scrollEndOffset = _this$props6.scrollEndOffset,
          searchDelay = _this$props6.searchDelay,
          showSearch = _this$props6.showSearch,
          value = _this$props6.value,
          visibleOptions = _this$props6.visibleOptions,
          width = _this$props6.width;
      var _this$state = this.state,
          focused = _this$state.focused,
          highlightedIndex = _this$state.highlightedIndex,
          open = _this$state.open,
          selectedOptions = _this$state.selectedOptions,
          titleLongerThanBox = _this$state.titleLongerThanBox;
      var hasSelectedItems = selectedOptions.length > 0;
      var title = this.getTitle();
      var titleClasses = {
        'vn-select__title': true,
        'vn-select__title--disabled': this.isDisabled(),
        'vn-select__title--error': error,
        'vn-select__title--focused': open || focused && !error,
        'vn-select__title--open': open,
        'vn-select__title--open_upwards': open && optionsOrientation.includes('up')
      };
      var titleTextClasses = {
        'vn-select__title-text': true,
        'vn-select__title-text--disabled': this.isDisabled(),
        'vn-select__title-text--two-buttons': hasSelectedItems && clearIcon,
        'vn-select__title-text--placeholder': !this.isDisabled() && !hasSelectedItems
      };
      return _react.default.createElement("div", {
        className: "vn-select",
        ref: function ref(node) {
          _this2.selectNode = node;
        },
        id: id,
        style: width ? {
          width: "".concat(width, "px")
        } : undefined
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)(titleClasses)
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)(titleTextClasses),
        ref: function ref(node) {
          _this2.titleTextNode = node;
        },
        role: "button",
        tabIndex: -1,
        title: titleLongerThanBox && hasSelectedItems ? "".concat(selectedOptions.length, " ").concat(i18n.selected) : title,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onKeyPress: this.handleKeyPress
      }, titleLongerThanBox && hasSelectedItems ? "".concat(selectedOptions.length, " ").concat(i18n.selected) : this.addIconIfNeeded(title)), _react.default.createElement("div", {
        "aria-hidden": "true",
        className: (0, _classnames.default)(titleTextClasses),
        ref: function ref(node) {
          _this2.hiddenTitleTextNode = node;
        },
        style: {
          visibility: 'hidden'
        }
      }, title), _react.default.createElement("div", {
        className: "vn-select__button-group"
      }, !readOnly && hasSelectedItems && clearIcon && _react.default.createElement("button", {
        "aria-label": i18n.clear,
        className: "vn-select__button",
        tabIndex: 0,
        title: i18n.clear,
        type: "button",
        onBlur: this.handleBlur,
        onClick: this.handleClearClick,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDownClear,
        onKeyPress: this.handleKeyPress
      }, _react.default.createElement(_icon.default, {
        color: "neutral",
        name: "close"
      })), _react.default.createElement("button", {
        "aria-label": i18n.open,
        tabIndex: 0,
        title: i18n.open,
        type: "button",
        className: "vn-select__button",
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onKeyPress: this.handleKeyPress
      }, _react.default.createElement(_icon.default, {
        disabled: this.isDisabled(),
        name: "chevron"
      })))), open && _react.default.createElement(_select_content.default, {
        error: error,
        highlightedIndex: highlightedIndex,
        noResults: i18n.noResults,
        multiple: multiple,
        onChange: this.handleChange,
        onScrollEnd: onScrollEnd,
        onSearch: onSearch,
        options: options,
        optionsOrientation: optionsOrientation,
        scrollEndOffset: scrollEndOffset,
        searchDelay: searchDelay,
        searchPlaceholder: i18n.searchPlaceholder,
        showSearch: showSearch,
        value: value,
        visibleOptions: visibleOptions
      }));
    }
  }]);

  return Select;
}(_react.Component);

Select.propTypes = {
  clearIcon: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  displayOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    flag: _propTypes.default.string,
    disabled: _propTypes.default.bool,
    icon: _propTypes.default.string,
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired
  })),
  error: _propTypes.default.bool,
  i18n: _propTypes.default.shape({
    clear: _propTypes.default.string.isRequired,
    noResults: _propTypes.default.string.isRequired,
    open: _propTypes.default.string.isRequired,
    searchPlaceholder: _propTypes.default.string.isRequired,
    selected: _propTypes.default.string.isRequired
  }),
  id: _propTypes.default.string,
  multiple: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onClear: _propTypes.default.func,
  onScrollEnd: _propTypes.default.func,
  onSearch: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    flag: _propTypes.default.string,
    disabled: _propTypes.default.bool,
    icon: _propTypes.default.string,
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
    altLabel: _propTypes.default.string
  })).isRequired,
  optionsOrientation: _propTypes.default.arrayOf(_propTypes.default.string),
  placeholder: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  scrollEndOffset: _propTypes.default.number,
  searchDelay: _propTypes.default.number,
  showSearch: _propTypes.default.bool,
  value: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])),
  visibleOptions: _propTypes.default.number,
  width: _propTypes.default.number
};
Select.defaultProps = {
  clearIcon: true,
  disabled: false,
  displayOptions: undefined,
  error: false,
  i18n: {
    clear: 'Clear',
    noResults: 'No results found',
    open: 'Open',
    searchPlaceholder: 'Search',
    selected: 'Selected'
  },
  id: undefined,
  multiple: false,
  onChange: function onChange() {},
  onClear: function onClear() {},
  onScrollEnd: undefined,
  onSearch: function onSearch() {},
  optionsOrientation: [],
  placeholder: '',
  readOnly: false,
  scrollEndOffset: 0,
  searchDelay: undefined,
  showSearch: false,
  value: [],
  visibleOptions: 10,
  width: undefined
};
Select.displayName = 'Select';
var _default = Select;
exports.default = _default;